module.exports = __webpack_public_path__ + "media/dogs/dog-jumping-61edb117.svg";